module.exports = __webpack_public_path__ + "/font/fontawesome-webfont_f775f9.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.5.0
 ** module id = 475
 ** module chunks = 0
 **/